import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from "@angular/router";
import { RoutesEnum, RoutingService } from "../routing.service";
import { AccountService } from "@Services/config";
import { CaseSummarySettingsService } from "@Services/case/case-summary-settings.service";
import { Utils } from '@Utils';
import { map, take, switchMap, from, Observable } from "rxjs";

@Injectable()
export class AccountSettingGuard implements CanActivate {
        
    constructor(
    private routingService: RoutingService,
    public accountService: AccountService,
    private caseSummarySettingsService: CaseSummarySettingsService,
    private router: Router
    ) {}
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const requiredSetting: string = route.data["requiredSetting"] as string;
        const isEnabled: boolean = route.data["isEnabled"] as boolean;
        const updatedRoute: RoutesEnum = route.data["routeRedirect"] as RoutesEnum || RoutesEnum.dashboard;
        this.caseSummarySettingsService.startCaseLoad(route.params.caseId);

        return from(this.accountService.getTargetAccount(route.params.accountCode, route.params.versionNumber, false)).pipe(
            switchMap(target =>
                this.caseSummarySettingsService.loadAccountSettings(target.id, target.clientId).pipe(
                    take(1),
                    map(accountSettings => {
                        const setting = accountSettings.find(s => s.name === requiredSetting);
                        if (setting && setting.value === 'true' && !isEnabled) {
                            return this.router.parseUrl(this.routingService.createUrl(updatedRoute, route.params));
                        } else if ((Utils.isNullOrWhitespace(setting?.value) || setting?.value === 'false') && isEnabled) {
                            return this.router.parseUrl(this.routingService.createUrl(updatedRoute, route.params));
                        } else {
                            return true;
                        }
                    })
                )
            )
        );
    }
}
